import React, { ReactNode } from 'react';
import classnames from 'classnames';

import './default-button.scss';
import { ButtonModifier, getBtnModifiersClasses } from '../../../infrastructure/helpers';


export interface ButtonProp {
    modifier?: ButtonModifier | ButtonModifier[];
    text: string | object | ReactNode;
    type?: 'button' | 'submit' | 'reset';
    className?: string | null;
    onClick?: (event: React.MouseEvent) => void;
    icon?: React.ComponentClass | React.FunctionComponent;
    disabled?: boolean;
    isActive?: boolean;
    withEllipsis?: boolean;
    dataTestId?: string;
}

const DefaultButton = React.forwardRef((props: ButtonProp, ref: React.Ref<HTMLButtonElement>) => {
    const {
        modifier,
        text,
        type,
        className,
        onClick,
        disabled,
        isActive,
        withEllipsis = false,
        dataTestId,
    } = props;
    const btnClasses = classnames(
        getBtnModifiersClasses(modifier),
        className,
        { 'active': isActive }
    );

    const typeProp = type ? type : 'button';

    return (
        <button
            ref={ref}
            onClick={disabled ? undefined : onClick}
            type={typeProp}
            className={btnClasses}
            disabled={disabled}
            data-test-id={dataTestId}
        >
            {props.icon && <props.icon />}
            <span className={classnames({ 'overflow-ellipsis': withEllipsis })}>{text}</span>
        </button>
    );
});

export default DefaultButton;
